import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageCustomerReturn from "../components/ManageCustomerReturn";

const ManageCustomerReturnPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Add Blog' />

                <ManageCustomerReturn />

            </MasterLayout>
        </>
    );
};

export default ManageCustomerReturnPage;
